import { 
    distanseBetweenLayers, 
    ballDiametr, 
    dotDiametr, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot, 
    parabolic,
    END_SIMPLE_ANIMATION_TIME,
} from '../../initials';
export class EndSimpleFallAnimationStartTopRight {
    constructor({
        fromRowIndex,
        fromDotIndex,
        isLeftMove,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.isLeftMove = isLeftMove;
        this.dots = dots;

    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'EndSimpleFallAnimationStartTopLeft',
            fromBallPositionByDot: BallPositionByDot.TOP_RIGHT,
            toBallPositionByDot: BallPositionByDot.CENTER,
        };
    }

    getAnimationTime() {
        return END_SIMPLE_ANIMATION_TIME;
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const middleDot = this.isLeftMove ? this.dots[this.fromRowIndex - 1][this.fromDotIndex - 1] : this.dots[this.fromRowIndex - 1][this.fromDotIndex];
        const endPosition = {
            x: middleDot.dotX,
            y: this.dots[this.dots.length - 1][0].dotY + ballDiametr * 2.5,
        };

        const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, Math.PI / 4);

        return {
            x: parabolic(
                startXY.x,
                middleDot.dotX, 
                endPosition.x, 
                t,
            ),
            y: parabolic(
                startXY.y,
                middleDot.dotY - distanseBetweenLayers / 2,
                endPosition.y - dotDiametr * 2, 
                t,
            ),
        };
    }
}